import { get } from '@common/Http';
import { PRODUCT_API_NAVIGATION_PRODUCTS } from '@routes';

export const fetchCarouselProducts = (url) => {
    const sliderParams = new URLSearchParams(url.split('?')?.[1]) ?? 'navId=0';
    const navigationId = sliderParams.get('navId');

    return get(PRODUCT_API_NAVIGATION_PRODUCTS, { navigationId });
};
